import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, merge, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from '../../definition';
import { TranslateService } from '@ngx-translate/core';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'mm-menu-tree',
  templateUrl: './menu-tree.component.html',
  styleUrls: ['./menu-tree.component.scss']
})
export class MenuTreeComponent implements OnInit {

  items$ = new BehaviorSubject<MenuItem[]>([]);
  constructor(private router: Router, private translateService: TranslateService, private httpClient: HttpClient) { }

  currentLang$ = merge(
    of(this.translateService.currentLang || this.translateService.defaultLang),
    this.translateService.onLangChange.pipe(map(c => c.lang))
  ).pipe(
    distinctUntilChanged()
  )
  async ngOnInit() {
    if (this.useDefaultSource) {
      let items = await this.httpClient.get<MenuItem[]>("_menu").toPromise();
      this.items$.next(items)
    }
  }
  hasItems(item: MenuItem) {
    return item.items && item.items.length > 0;
  }
  navigate(paths: string[]) {
    this.router.navigate(paths);
  }

  combinePaths(paths: string[], path: string) {
    return [...paths, path];
  }

  @Input()
  set items(_: MenuItem[]) {
    this.items$.next(_);
  }

  @Input()
  useDefaultSource = false;


  @Input()
  mmInlineCollapsed = false;

  menuName(_: MenuItem) {
    // if (!_.names) {
    //   return of(_.name)
    // }
    return this.currentLang$.pipe(
      map(lang => _.localizedName)
    )

  }

}
